import {Injectable, effect, signal, inject, DestroyRef, computed} from '@angular/core';
import { BehaviorSubject, Subscription } from "rxjs";
import { SpeechSynthesizerService } from '@llm/service/speech_synthesizer.service';
import { UiStateService } from '@llm/service/signals_ui_state.service';
import { SnackbarService } from '@serv/snackbar.service';
import { llmStoreService, RecordingStatus } from '@llm/service/llm_store.service';
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";
import {MicrophoneService} from '@serv/media_access/api_web_access_microphone.service';
import * as UtilityMediaAccess from '@serv/media_access/utility';
import {DevicePermissionsService} from '@serv/media_access/devices_permissions.service';
@Injectable({
  providedIn: 'root'
})
export class SpeechRecognitionService {
  private readonly CONSUMER_ID: UtilityMediaAccess.MicrophoneConsumer = 'COMMAND_DETECTOR';
  private store = inject(llmStoreService);
  private _uiStateService = inject(UiStateService);
  private speechSynthesizerService = inject(SpeechSynthesizerService);
  private destroyRef = inject(DestroyRef);
  private _console = inject(Tools_aiConsoleService);
  private _accessMicSvc = inject(MicrophoneService);
  private _devicePermissionSrv = inject(DevicePermissionsService);

  //---PROPIEDADES PÚBLICAS Y ESTADO INTERNO SIMPLIFICADO

  public transcriptionSession = computed(() => this._accessMicSvc.transcriptionSession());

  public is_command_detecter_active = computed(() =>
    this._accessMicSvc.isRecognizing() && this._accessMicSvc.isConsumerActive(this.CONSUMER_ID)
  );

  constructor() {
    this.setupStateListeners();
    this.setupCleanup();
  }


  private setupStateListeners(): void {

    // --- EL CEREBRO DEL SERVICIO ---
    // Este efecto preserva tu lógica compleja para decidir CUÁNDO escuchar.
    effect(() => {
      const disabled = true;
      const intentActive = this.store.isInteractionVoiceIntentStatus();
      const isSpeaking = this.store.isSpeaking();
      const shouldBeRunning = intentActive && !isSpeaking

      if (shouldBeRunning && !disabled) {
        this._accessMicSvc.requestLock(this.CONSUMER_ID);
      } else {
        if (this._accessMicSvc.isConsumerActive(this.CONSUMER_ID)) {
          this._console.debug(`Liberando bloqueo del micrófono. Razón: intent=${intentActive}, speaking=${isSpeaking}`);
          this._accessMicSvc.releaseLock(this.CONSUMER_ID);
        }
      }
    }, { allowSignalWrites: true });

    effect(() => { // Solo procesamos si somos el consumidor activo
      if (this.is_command_detecter_active()) {
        const transcript = this._accessMicSvc.transcriptionSession();
        if (transcript) {
          this.store.setTranscriptionSession(transcript);
         this._console.log('transcript:', transcript)
        }
      }
    }, {'allowSignalWrites': true});
  }

  private setupCleanup(): void {
    this.destroyRef.onDestroy(() => {
      this._console.debug('Limpiando recursos de SpeechRecognitionService.');
      this._accessMicSvc.releaseLock(this.CONSUMER_ID);
    });
  }
}
